import { render, staticRenderFns } from "./ImportBloquear.vue?vue&type=template&id=34228670&scoped=true"
import script from "./ImportBloquear.vue?vue&type=script&lang=js"
export * from "./ImportBloquear.vue?vue&type=script&lang=js"
import style0 from "./ImportBloquear.vue?vue&type=style&index=0&id=34228670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34228670",
  null
  
)

export default component.exports